// Google Maps polygon path (array of {lat,lng}) <-> GeoJSON Polygon geometry.
// GeoJSON rings are closed and use [lng, lat] order (RFC 7946); Google Maps
// paths are open and use {lat, lng}.

export function pathToPolygonGeometry(path) {
  if (!Array.isArray(path) || path.length < 3) {
    throw new Error('A polygon needs at least 3 points');
  }
  const ring = path.map((p) => [p.lng, p.lat]);
  const [fx, fy] = ring[0];
  const [lx, ly] = ring[ring.length - 1];
  if (fx !== lx || fy !== ly) ring.push([fx, fy]);
  return { type: 'Polygon', coordinates: [ring] };
}

export function polygonGeometryToPath(geometry) {
  if (!geometry || geometry.type !== 'Polygon' || !Array.isArray(geometry.coordinates)) {
    return [];
  }
  const ring = geometry.coordinates[0] || [];
  const out = ring.map(([lng, lat]) => ({ lat, lng }));
  if (out.length > 1) {
    const a = out[0];
    const b = out[out.length - 1];
    if (a.lat === b.lat && a.lng === b.lng) out.pop();
  }
  return out;
}
